/**
 * Video module
 *
 * @module Video
 */
(function Video(){

    /**
     * Provided function gets called when browser is ready for js rendering
     * @param fn
     */
    function ready(fn) {
        if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    /**
     * Rendering a simple video
     * @param {dom} simpleContentElement
     * @class {simpleVideo}
     * @constructor
     */
    function simpleVideo(videoContentElement) {
        var video = videoContentElement.querySelectorAll('video')[0];
        var playButton = videoContentElement.querySelectorAll('[data-techdivision-simplevideo="play"]')[0];
        // play video on click
        playButton.addEventListener("click", function() {
            // hide play button
            playButton.style.display = "none";
            video.setAttribute("controls","controls");
            video.play();
        }, false);

        // display button when video has ended
        video.addEventListener('ended',function() {
            playButton.style.display = "block";
            video.removeAttribute("controls");
        },false);
    }

    /**
     * Rendering a embed video
     * @param {dom} embedVideoContentElement
     * @class {embedVideo}
     * @constructor
     */
    function embedVideo(videoContentElement) {
        var video = videoContentElement.querySelectorAll('iframe')[0];
        var playButton = videoContentElement.querySelectorAll('[data-techdivision-embedvideo="play"]')[0];
        var previewImage = videoContentElement.querySelectorAll('[data-techdivision-embedvideo="image"]')[0];

        if(previewImage) {
            // play video on click
            playButton.addEventListener("click", function() {
                // hide play button
                playButton.style.display = "none";
                previewImage.style.display = "none";
                video.src += '&autoplay=1';
            }, false);
        }

        // display button when video has ended
        video.addEventListener('ended',function() {
            playButton.style.display = "block";
        },false);
    }

    ready(function() {
        // iterate all video content elements and create instances
        var simpleVideoContentElements = document.querySelectorAll('[data-techdivision-simplevideo="wrapper"]');
        var embedVideoContentElements = document.querySelectorAll('[data-techdivision-embedvideo="wrapper"]');
        for (i = 0; i < simpleVideoContentElements.length; ++i) {
            var simdpleVideoInstance = new simpleVideo(simpleVideoContentElements[i]);
        }
        for (i = 0; i < embedVideoContentElements.length; ++i) {
            var embedVideoInstance = new embedVideo(embedVideoContentElements[i]);
        }
    });
})();